// src/components/display/PhotoGallery.js
import { Gallery, Item } from "react-photoswipe-gallery";
import "photoswipe/dist/photoswipe.css";

export default function PhotoGallery() {
	return (
		<Gallery options={{ bgClickAction: "close" }}>
			<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-10 gap-4 mb-8">
				{/* First and Second Image Group */}
				<div className="sm:col-span-1 md:col-span-3 row-span-2 flex flex-col gap-4">
					<Item
						original={"https://cdn.rentiq.com/samples/riverview-residences/optimized/amenities-2.webp"}
						thumbnail={"https://cdn.rentiq.com/samples/riverview-residences/fallback/amenities-2.jpeg"}
						width="1620"
						height="1080"
					>
						{({ ref, open: openItem }) => (
							<picture className="w-full h-full">
								<source
									srcSet="https://cdn.rentiq.com/samples/riverview-residences/optimized/amenities-2.webp"
									type="image/webp"
								/>
								<img
									ref={ref}
									onClick={openItem}
									src="https://cdn.rentiq.com/samples/riverview-residences/fallback/amenities-2.jpeg"
									alt="Luxurious amenities at Riverview Residences"
									loading="lazy"
									className="w-full h-full object-cover transition-transform duration-500 hover:scale-102 cursor-pointer"
								/>
							</picture>
						)}
					</Item>
					<Item
						original={"https://cdn.rentiq.com/samples/riverview-residences/optimized/living.webp"}
						thumbnail={"https://cdn.rentiq.com/samples/riverview-residences/fallback/living.jpeg"}
						width="1452"
						height="1080"
					>
						{({ ref, open: openItem }) => (
							<picture className="w-full h-full">
								<source
									srcSet="https://cdn.rentiq.com/samples/riverview-residences/optimized/living.webp"
									type="image/webp"
								/>
								<img
									ref={ref}
									onClick={openItem}
									src="https://cdn.rentiq.com/samples/riverview-residences/fallback/living.jpeg"
									alt="Comfortable living area in Riverview Residences"
									loading="lazy"
									className="w-full h-full object-cover transition-transform duration-500 hover:scale-102 cursor-pointer"
								/>
							</picture>
						)}
					</Item>
				</div>

				{/* Third and Fourth Image Group */}
				<div className="sm:col-span-1 md:col-span-3 row-span-2 flex flex-col gap-4">
					<Item
						original={"https://cdn.rentiq.com/samples/riverview-residences/optimized/bathroom.webp"}
						thumbnail={"https://cdn.rentiq.com/samples/riverview-residences/fallback/bathroom.jpeg"}
						width="1620"
						height="1080"
					>
						{({ ref, open: openItem }) => (
							<picture className="w-full h-full">
								<source
									srcSet="https://cdn.rentiq.com/samples/riverview-residences/optimized/bathroom.webp"
									type="image/webp"
								/>
								<img
									ref={ref}
									onClick={openItem}
									src="https://cdn.rentiq.com/samples/riverview-residences/fallback/bathroom.jpeg"
									alt="Modern bathroom in Riverview Residence"
									loading="lazy"
									className="w-full h-full object-cover transition-transform duration-500 hover:scale-102 cursor-pointer"
								/>
							</picture>
						)}
					</Item>
					<Item
						original={"https://cdn.rentiq.com/samples/riverview-residences/optimized/den-2.webp"}
						thumbnail={"https://cdn.rentiq.com/samples/riverview-residences/fallback/den-2.jpeg"}
						width="1620"
						height="1080"
					>
						{({ ref, open: openItem }) => (
							<picture className="w-full h-full">
								<source
									srcSet="https://cdn.rentiq.com/samples/riverview-residences/optimized/den-2.webp"
									type="image/webp"
								/>
								<img
									ref={ref}
									onClick={openItem}
									src="https://cdn.rentiq.com/samples/riverview-residences/fallback/den-2.jpeg"
									alt="Cozy den area in Riverview Residences"
									loading="lazy"
									className="w-full h-full object-cover transition-transform duration-500 hover:scale-102 cursor-pointer"
								/>
							</picture>
						)}
					</Item>
				</div>

				{/* Fifth Image - Larger Image Spanning Full Width */}
				<div className="sm:col-span-2 md:col-span-4 row-span-2">
					<Item
						original={"https://cdn.rentiq.com/samples/riverview-residences/optimized/home.webp"}
						thumbnail={"https://cdn.rentiq.com/samples/riverview-residences/fallback/home.jpeg"}
						width="720"
						height="1280"
					>
						{({ ref, open: openItem }) => (
							<picture className="w-full h-full">
								<source
									srcSet="https://cdn.rentiq.com/samples/riverview-residences/optimized/home.webp"
									type="image/webp"
								/>
								<img
									ref={ref}
									onClick={openItem}
									src="https://cdn.rentiq.com/samples/riverview-residences/fallback/home.jpeg"
									alt="Spacious home interior at Riverview Residences"
									loading="lazy"
									className="w-full h-full object-cover transition-transform duration-500 hover:scale-102 cursor-pointer"
								/>
							</picture>
						)}
					</Item>
				</div>

				{/* Sixth Image - Larger Image Spanning Full Width on Small, Half on Larger Screens */}
				<div className="sm:col-span-2 md:col-span-4 row-span-2">
					<Item
						original={"https://cdn.rentiq.com/samples/riverview-residences/optimized/location-campus.webp"}
						thumbnail={"https://cdn.rentiq.com/samples/riverview-residences/fallback/location-campus.jpeg"}
						// width="1280"
						// height="853"
						width="810"
						height="1080"
					>
						{({ ref, open: openItem }) => (
							<picture className="w-full h-full">
								<source
									srcSet="https://cdn.rentiq.com/samples/riverview-residences/optimized/location-campus.webp"
									type="image/webp"
								/>
								<img
									ref={ref}
									onClick={openItem}
									src="https://cdn.rentiq.com/samples/riverview-residences/fallback/location-campus.jpeg"
									alt="Riverview Residences proximity to campus"
									loading="lazy"
									className="w-full h-full object-cover transition-transform duration-500 hover:scale-102 cursor-pointer"
								/>
							</picture>
						)}
					</Item>
				</div>
				{/* Seventh and Eighth Image Group */}
				<div className="sm:col-span-1 md:col-span-3 row-span-2 flex flex-col gap-4">
					<Item
						original={"https://cdn.rentiq.com/samples/riverview-residences/optimized/kitchen-2.webp"}
						thumbnail={"https://cdn.rentiq.com/samples/riverview-residences/fallback/kitchen-2.jpeg"}
						width="1623"
						height="1080"
					>
						{({ ref, open: openItem }) => (
							<picture className="w-full h-full">
								<source
									srcSet="https://cdn.rentiq.com/samples/riverview-residences/optimized/kitchen-2.webp"
									type="image/webp"
								/>
								<img
									ref={ref}
									onClick={openItem}
									src="https://cdn.rentiq.com/samples/riverview-residences/fallback/kitchen-2.jpeg"
									alt="Fully equipped kitchen in Riverview Residences"
									loading="lazy"
									className="w-full h-full object-cover transition-transform duration-500 hover:scale-102 cursor-pointer"
								/>
							</picture>
						)}
					</Item>
					<Item
						original={"https://cdn.rentiq.com/samples/riverview-residences/optimized/kitchen.webp"}
						thumbnail={"https://cdn.rentiq.com/samples/riverview-residences/fallback/kitchen.jpeg"}
						width="1620"
						height="1080"
					>
						{({ ref, open: openItem }) => (
							<picture className="w-full h-full">
								<source
									srcSet="https://cdn.rentiq.com/samples/riverview-residences/optimized/kitchen.webp"
									type="image/webp"
								/>
								<img
									ref={ref}
									onClick={openItem}
									src="https://cdn.rentiq.com/samples/riverview-residences/fallback/kitchen.jpeg"
									alt="Modern kitchen design at Riverview Residences"
									loading="lazy"
									className="w-full h-full object-cover transition-transform duration-500 hover:scale-102 cursor-pointer"
								/>
							</picture>
						)}
					</Item>
				</div>

				{/* Ninth and Tenth Image Group */}
				<div className="sm:col-span-1 md:col-span-3 row-span-2 flex flex-col gap-4">
					<Item
						original={"https://cdn.rentiq.com/samples/riverview-residences/optimized/location-amenities.webp"}
						thumbnail={"https://cdn.rentiq.com/samples/riverview-residences/fallback/location-amenities.jpeg"}
						width="810"
						height="1080"
					>
						{({ ref, open: openItem }) => (
							<picture className="w-full h-full">
								<source
									srcSet="https://cdn.rentiq.com/samples/riverview-residences/optimized/location-amenities.webp"
									type="image/webp"
								/>
								<img
									ref={ref}
									onClick={openItem}
									src="https://cdn.rentiq.com/samples/riverview-residences/fallback/location-amenities.jpeg"
									alt="Amenities near Riverview Residences"
									loading="lazy"
									className="w-full h-full object-cover transition-transform duration-500 hover:scale-102 cursor-pointer"
								/>
							</picture>
						)}
					</Item>
					<Item
						original={"https://cdn.rentiq.com/samples/riverview-residences/optimized/den.webp"}
						thumbnail={"https://cdn.rentiq.com/samples/riverview-residences/fallback/den.jpeg"}
						width="1920"
						height="1080"
					>
						{({ ref, open: openItem }) => (
							<picture className="w-full h-full">
								<source
									srcSet="https://cdn.rentiq.com/samples/riverview-residences/optimized/den.webp"
									type="image/webp"
								/>
								<img
									ref={ref}
									onClick={openItem}
									src="https://cdn.rentiq.com/samples/riverview-residences/fallback/den.jpeg"
									alt="Cozy den at Riverview Residences"
									loading="lazy"
									className="w-full h-full object-cover transition-transform duration-500 hover:scale-102 cursor-pointer"
								/>
							</picture>
						)}
					</Item>
				</div>
			</div>
		</Gallery>
	);
}
